import { render, staticRenderFns } from "./ShiftList.vue?vue&type=template&id=5f3fc06b&scoped=true&"
import script from "./ShiftList.vue?vue&type=script&lang=js&"
export * from "./ShiftList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f3fc06b",
  null
  
)

export default component.exports